<template>
  <b-modal
    :modal-class="[customModalClass, 'simonModal']"
    :dialog-class="[size === 'small' ? 'smallModal' : 'largeModal', 'w-100, simonModalDialog']"
    header-class="simonModalHeader"
    body-class="simonModalBody"
    content-class="simonModalContent"
    footer-class="simonModalFooter"
    hide-header-close
    :aria-label="ariaLabelModal"
    :hide-footer="hiddenFooter"
    :visible="isVisible"
    :id="id ? id + '_simonModal' : 'simonModal'"
    :no-close-on-backdrop="disabledClose"
    :no-close-on-esc="disabledClose"
    @hide="$emit('hide', $event)"
    @hidden="$emit('hidden', $event)"
    @shown="$emit('shown', $event)"
    @close="$emit('close', $event)"
    scrollable
    :no-fade="noFade"
  >
    <template #modal-header>
      <div class="modalTitle" v-if="stickyHeader">
        <slot class="modalTitle" name="modalTitle"/>
      </div>
      <button :class="[closeButtonColor, 'icon-only close']" :aria-label="btnIconCancelAlt" v-if="!hiddenCloseButton" @click="$emit('hide')">
        <img src="/files/flash/images/svg-icons/modal-close-violet.svg">
      </button>
    </template>

    <template #default>
      <div class="modalTitle" v-if="!stickyHeader">
        <slot class="modalTitle" name="modalTitle"/>
      </div>
      <slot/>
      <div class="modalAccordion" v-if="showAccordion">
        <simon-collapse id="simonModalCollapse" scroll-on-expanded :expanded="accordionExpanded"
                        @collapseUpdate="collapseUpdate">
          <template #headline><strong>{{ accordionTitle }}</strong></template>
          <template #content>
            <p class="card-text" v-if="accordionText" v-html="accordionText"/>
            <p class="cart-text" v-else>
              <slot name="accordionText"/>
            </p>
          </template>
        </simon-collapse>
      </div>
    </template>

    <template #modal-footer>
      <button tabindex="0" class="fluid-mobile" :class="cssClassCancelButton" v-if="!showFooterButtons"
              @click.prevent.stop="$emit(btnCancelEvent)">{{ btnCancelTitle }}
      </button>
      <Stepper
        v-else
        :css-class-prev="cssClassLeftButton"
        :css-class-next="cssClassRightButton ? cssClassRightButton + ' fluid-mobile' : 'filled fluid-mobile'"
        @prev="$emit('btnLeft')"
        @next="$emit('btnRight')"
        :disabled-next="disabledBtnRight"
        :loading-next="loadingRightBtn"
      >
        <template #btnPrev>{{ btnLeftTitle }}</template>
        <template #btnNext>{{ btnRightTitle }}</template>
      </Stepper>
    </template>
  </b-modal>
</template>

<script>
import Stepper from '@/components/generic/Stepper'
import SimonCollapse from '../generic/SimonCollapse.vue'

export default {
  name: 'SimonModal',
  components: {
    SimonCollapse,
    Stepper
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    customModalClass: {
      type: String,
      default: ''
    },
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    noFade: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small',
      validator: function (value) {
        return ['small', 'large'].includes(value)
      }
    },
    stickyHeader: {
      type: Boolean,
      default: false
    },
    hiddenCloseButton: {
      type: Boolean,
      default: false
    },
    hiddenFooter: {
      type: Boolean,
      default: false
    },
    closeButtonColor: {
      type: String,
      default: 'dark',
      validator: function (value) {
        return ['light', 'dark'].includes(value)
      }
    },
    disabledClose: {
      type: Boolean,
      default: false
    },
    showFooterButtons: {
      type: Boolean,
      default: false
    },
    btnIconCancelAlt: {
      type: String,
      default: 'Schließen'
    },
    btnCancelTitle: {
      type: String,
      default: 'Schließen'
    },
    btnCancelEvent: {
      type: String,
      default: 'hide'
    },
    btnLeftTitle: {
      type: String,
      default: 'Abbrechen'
    },
    btnRightTitle: {
      type: String,
      default: 'Verstanden'
    },
    cssClassLeftButton: {
      type: String
    },
    cssClassRightButton: {
      type: String
    },
    cssClassCancelButton: {
      type: String
    },
    disabledBtnRight: {
      type: Boolean,
      default: false
    },
    loadingRightBtn: {
      type: Boolean,
      default: false
    },
    showAccordion: {
      type: Boolean,
      default: false
    },
    accordionTitle: {
      type: String
    },
    accordionText: {
      type: String
    },
    accordionExpanded: {
      type: Boolean,
      default: false
    },
    ariaLabelModal: {
      type: String,
      default: ''
    }
  },
  methods: {
    collapseUpdate (e) {
      this.$emit('collapseUpdate', e)
    }
  }
}
</script>
